<template>
  <div class="row">
    <div class="col-12 your-details">
      <div>
        <div class="card with-padding with-shadow details">
          <div class="row">
            <div class="col-5">
              <ul>
                <li><span class="key">Driver Name: </span><span class="value">{{
                    profile.fullName
                  }}</span>
                </li>
                <li><span class="key">Driver Email: </span><span class="value">{{
                    profile.emailAddress
                  }}</span></li>
                <li><span class="key">Home Address: </span><span class="value">{{
                    profile.homeAddress
                  }}</span></li>
                <li><span class="key">Postcode: </span><span class="value">{{ profile.postcode }}</span>
                </li>
              </ul>
            </div>
            <div class="col-5">
              <ul>
                <li><span class="key">Mobile phone: </span><span class="value">{{
                    profile.mobile
                  }}</span>
                </li>
                <li><span class="key">Date of Birth: </span><span
                  class="value">{{ formatIsoDate(profile.dateOfBirth) }}</span></li>
                <li>
                  <span class="key">Tax Band:
                      <VDropdown :disabled="!tooltip">
                          <button class="tooltip-button"><i class="icon-info-solid"/></button>
                          <template #popper>
                              <p>{{ taxBandTooltip }}</p>
                          </template>
                      </VDropdown>
                  </span>
                  <span class="value">{{ profile.incomeTaxBand }}%</span>
                </li>
              </ul>
            </div>
            <div class="col-2 text-end">
              <button aria-label="Edit my details" @click.prevent="showEditDriverForm" class="button button--xsmall button--steelBlue-ghost">
                Edit my details
              </button>
<!--                        <button aria-label="Set charging profile" @click.prevent="showChargingProfileForm" class="button button&#45;&#45;xsmall button&#45;&#45;steelBlue-ghost">
                Set charging profile
              </button>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slideout"
      :class="{ 'slideout--show' : slideoutVisible }">

      <div v-if="slideoutVisible">

        <!-- Header -->
        <div class="row">
          <div class="col-10 text-start">
            <div>
              <h3><span>{{ product.scheme_card_main_driver_heading_text }}</span></h3>
              <p>{{ product.scheme_card_main_driver_heading_description }}</p>

              <form method="POST" @submit.prevent="updateDriverProfile" id="edit-driver-profile-form">
                <h6>Your Name:</h6>

                <div class="row mb-4">
                  <div class="col-6">
                    <div class="input firstname">
                      <input type="text" class="firstname" name="firstname"
                        id="driver-profile-firstname" v-model="payload.firstname" required>
                      <label for="driver-profile-firstname">Firstname</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="input surname">
                      <input type="text" class="surname" name="surname"
                        id="driver-profile-surname" v-model="payload.surname" required>
                      <label for="driver-profile-surname">Surname</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input email">
                      <input type="email" class="email" name="email" id="driver-profile-email"
                        v-model="payload.email" required>
                      <label for="driver-profile-email">Driver Email</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="lightswitch lightswitch-left">
                      <input type="checkbox" name="mainDriver" id="driver-profile-main-driver"
                        class="main-driver" v-model="payload.mainDriver">
                      <label for="driver-profile-main-driver">Set as Main Driver</label>
                    </div>
                  </div>
                </div>

                <h6>Address:</h6>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input address">
                      <input type="text" class="address" name="address"
                        id="driver-profile-address" v-model="payload.address" required>
                      <label for="driver-profile-address">Address</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input postcode">
                      <input type="text" class="postcode" name="postcode"
                        id="driver-profile-postcode" v-model="payload.postcode" required>
                      <label for="driver-profile-postcode">Postcode</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input mobile-phone">
                      <input type="text" class="mobile-phone" name="mobilePhone"
                        id="driver-profile-mobile-phone" v-model="payload.mobilePhone" required>
                      <label for="driver-profile-mobile-phone">Mobile Phone</label>
                    </div>
                  </div>
                </div>

                <h6>Date of Birth:</h6>

                <div class="row mb-3">
                  <div class="col-6">
                    <div class="custom-multiselect">
                      <label for="driver-profile-dob-month">Month</label>
                      <multiselect
                        id="driver-profile-dob-month"
                        v-model="payload.dob.month"
                        :options="months"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="custom-multiselect">
                      <label for="driver-profile-dob-day">Day</label>
                      <multiselect
                        id="driver-profile-dob-day"
                        v-model="payload.dob.day"
                        :options="daysInMonth(payload.dob.month, payload.dob.year)"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="custom-multiselect">
                      <label for="driver-profile-dob-year">Year</label>
                      <multiselect
                        id="driver-profile-dob-year"
                        v-model="payload.dob.year"
                        :options="years()"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="input driving-license">
                      <input type="text" class="driving-license" name="drivingLicense"
                        id="driver-profile-driving-license" v-model="payload.drivingLicense"
                        required>
                      <label for="driver-profile-driving-license">Driving License #:</label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="custom-multiselect">
                      <label for="driver-profile-tax-band">Tax Band (%)</label>
                      <multiselect
                        id="driver-profile-tax-band"
                        v-model="payload.taxBand"
                        :options="taxBands"
                        group-values="options"
                        group-label="group"
                        :group-select="false"
                        :show-labels="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="d-block mb-2">Is the driver a permanent UK resident?</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="points"
                        id="driver-profile-permanent-uk-resident-yes"
                        value="Yes"
                        v-model="payload.insuranceQuestions['Is the driver a permanent UK resident']"
                        required>
                      <label for="driver-profile-permanent-uk-resident-yes"
                        class="form-check-label"><b>Yes</b></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="points"
                        id="driver-profile-permanent-uk-resident-no"
                        value="No"
                        v-model="payload.insuranceQuestions['Is the driver a permanent UK resident']"
                        required>
                      <label for="driver-profile-permanent-uk-resident-no"
                        class="form-check-label"><b>No</b></label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="d-block mb-2">Does the driver hold a full hold a full licence from the
                      UK, EU, EEA, or one of the countries listed within the Insurance Eligibility
                      Criteria document?</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="full-valid-license"
                        id="driver-profile-full-valid-license-yes" value="Yes"
                        v-model="payload.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']"
                        required>
                      <label for="driver-profile-full-valid-license-yes"
                        class="form-check-label"><b>Yes</b></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="full-valid-license"
                        id="driver-profile-full-valid-license-no" value="No"
                        v-model="payload.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']"
                        required>
                      <label for="driver-profile-full-valid-license-no" class="form-check-label"><b>No</b></label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="d-block mb-2">Has the driver had more than 2 convictions within the
                      last 3 years within any of the following letters on their licence; CU, LC,
                      MW, PC, SP or TS?</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="convictions"
                        id="driver-profile-convictions-yes"
                        value="Yes"
                        v-model="payload.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']"
                        required>
                      <label for="driver-profile-convictions-yes" class="form-check-label"><b>Yes</b></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="convictions" id="driver-profile-convictions-no"
                        value="No"
                        v-model="payload.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']"
                        required>
                      <label for="driver-profile-convictions-no" class="form-check-label"><b>No</b></label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="d-block mb-2">Has the driver had any conviction in the last 5 years
                      with any of the following letters on their licence; AC, BA, CD, DD, DG, DR,
                      IN, MS, TT or UT?</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="convictions-other"
                        id="driver-profile-convictions-other-yes" value="Yes"
                        v-model="payload.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']"
                        required>
                      <label for="driver-profile-convictions-other-yes"
                        class="form-check-label"><b>Yes</b></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="convictions-other"
                        id="driver-profile-convictions-other-no" value="No"
                        v-model="payload.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']"
                        required>
                      <label for="driver-profile-convictions-other-no" class="form-check-label"><b>No</b></label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="d-block mb-2">Has the driver received any conviction which has resulted
                      in a driving ban in the last 5 years?</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="ban" id="driver-profile-ban-yes" value="Yes"
                        v-model="payload.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']"
                        required>
                      <label for="driver-profile-ban-yes" class="form-check-label"><b>Yes</b></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="ban" id="driver-profile-ban-no" value="No"
                        v-model="payload.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']"
                        required>
                      <label for="driver-profile-ban-no" class="form-check-label"><b>No</b></label>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-12">
                    <label class="d-block mb-2">Has the driver had more than 1 FAULT claim in the last 3
                      years?</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="faults" id="driver-profile-faults-yes"
                        value="Yes"
                        v-model="payload.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years']"
                        required>
                      <label for="driver-profile-faults-yes" class="form-check-label"><b>Yes</b></label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="faults" id="driver-profile-faults-no"
                        value="No"
                        v-model="payload.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years']"
                        required>
                      <label for="driver-profile-faults-no" class="form-check-label"><b>No</b></label>
                    </div>
                  </div>
                </div>

                <input type="submit" value="Save" class="button button--steelBlue float-end">

              </form>
            </div>
          </div>
          <div class="col-2 text-end">
            <button @click="hideSlideout" class="close"><i class="icon-cross"></i></button>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script>

import {EventBus} from '@/event-bus.js';
import Multiselect from 'vue-multiselect';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export default {
  name: 'salsac-your-details-component',
  components: {
    Multiselect
  },

  props: [
    'mileagePercent',
    'profile',
    'product',
    'schemeType',
    'tooltip',
    'taxBandTooltip',
  ],

  data() {
    return {
      slideoutVisible: false,
      months: months,
      taxBands: [
        {
          group: 'Tax Rates',
          options: [20, 40, 45]
        },
        /*{
          group: 'Scottish Tax Rates',
          options: [19, 21, 42, 48]
        }*/
      ],
      payload: {
        firstname: null,
        surname: null,
        email: null,
        mainDriver: null,
        address: null,
        postcode: null,
        mobilePhone: null,
        dob: this.getDateOfBirth(),
        drivingLicense: null,
        taxBand: null,
        insuranceQuestions: {
          'Is the driver a permanent UK resident': null,
          'Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document': null,
          'Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS': null,
          'Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT': null,
          'Has the driver received any conviction which has resulted in a driving ban in the last 5 years': null,
          'Has the driver had more than 1 FAULT claim in the last 3 years': null
        },
        scheme: 'salsac',
      },
    };
  },

  mounted() {
    EventBus.$on('editProfile', (editProfile) => {
      this.showEditDriverForm();
    });
  },

  methods: {
    showSlideout(context) {
      this.slideoutVisible = true;
    },

    showChargingProfileForm() {
      EventBus.$emit('charging-slideout-visible');
    },

    hideSlideout() {
      this.slideoutVisible = false;
    },

    showEditDriverForm() {
      this.payload = {
        firstname: this.getFirstName(),
        surname: this.getSurname(),
        email: this.profile.emailAddress,
        mainDriver: Boolean(this.profile.mainDriver),
        address: this.profile.homeAddress,
        postcode: this.profile.postcode,
        mobilePhone: this.profile.mobile,
        dob: this.getDateOfBirth(),
        drivingLicense: this.profile.driverLicence?.licenceNumber,
        taxBand: this.profile.incomeTaxBand,
        insuranceQuestions: {
          'Is the driver a permanent UK resident': (this.profile.insuranceQuestions && this.profile.insuranceQuestions['Is the driver a permanent UK resident'] ? this.profile.insuranceQuestions['Is the driver a permanent UK resident'] : null),
          'Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document': (this.profile.insuranceQuestions && this.profile.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document'] ? this.profile.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document'] : null),
          'Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS': (this.profile.insuranceQuestions && this.profile.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS'] ? this.profile.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS'] : null),
          'Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT': (this.profile.insuranceQuestions && this.profile.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT'] ? this.profile.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT'] : null),
          'Has the driver received any conviction which has resulted in a driving ban in the last 5 years': (this.profile.insuranceQuestions && this.profile.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years'] ? this.profile.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years'] : null),
          'Has the driver had more than 1 FAULT claim in the last 3 years': (this.profile.insuranceQuestions && this.profile.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years'] ? this.profile.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years'] : null)
        }
      }

      this.showSlideout();
    },

    getFirstName() {
      const parts = this.profile.fullName.split(' ');
      return parts.length ? parts[0] : '';
    },

    getSurname() {
      const parts = this.profile.fullName.split(' ');
      return parts.length ? parts[parts.length - 1] : '';
    },

    getDateOfBirth() {
      const dob = this.profile.dateOfBirth ? new Date(this.profile.dateOfBirth) : new Date();

      return {
        month: months[parseInt(dob.getMonth())],
        day: dob.getDate(),
        year: dob.getFullYear()
      };
    },

    updateDriverProfile() {

      if (this.payload.dob.year === new Date().getUTCFullYear()) {
        alert('Please ensure the Date of Birth field is configured correctly.')
        return;
      }

      EventBus.$emit('loadingTitle', 'Updating Driver Profile');
      EventBus.$emit('loading', true);

      this.$http.post('/api/your-profile', this.payload)
        .then(response => {
          EventBus.$emit('loading', false);

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: 'Driver Profile saved successfully'
          });

          this.hideSlideout();

          EventBus.$emit('reload-driver-profile');
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response?.error?.message
          });
        });
    },

    years() {
      const now = new Date().getUTCFullYear();
      const years = Array(now - (now - 80)).fill('').map((v, idx) => now - idx);
      return years;
    },

    daysInMonth(month, year) {
      const monthInt = this.months.indexOf(month) + 1;
      const totalDays = new Date(year, monthInt, 0).getDate();
      const days = [];

      let day = 1;

      while (day <= totalDays) {
        days.push(day++);
      }

      return days;
    },

    formatIsoDate(isoDate) {
      let formattedDate = '';

      if (isoDate) {
        formattedDate = new Date(isoDate).toLocaleString('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
      }

      return formattedDate;
    }
  },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
